'use client'

import Link from 'next/link'
import { useMemo, useState } from 'react'

import { Authorization } from '@/widgets/Authorization'

import { useCheckAuth } from '@/features/auth/check'

import { FullWidthContainer } from '@/shared/lib/components/full-width-container'
import { Modal } from '@/shared/ui'
import { ElementsSliderFree } from '@/shared/ui/elements-slider-free'

import { ServiceElement } from '../ServiceElement/ServiceElement'

import { data } from './data'

import cl from './ServiceLIst.module.scss'

export const ServiceList = () => {
	const { isAuthorized } = useCheckAuth()

	const [isAuthModalOpen, setIsAuthModalOpen] = useState(false)

	const onOpenAuthModal = () => setIsAuthModalOpen(true)
	const onCloseAuthModal = () => setIsAuthModalOpen(false)

	const slides = useMemo(
		() =>
			data.map(item => (
				<>
					{item?.authorizedField && isAuthorized ? ( // show block for authorized user
						<Link href={item.link} prefetch={false} key={`${item.link}_auth`}>
							<ServiceElement
								icon={item.icon}
								text={item.authorizedField.text}
								aria-label={item.authorizedField.ariaLabel}
							/>
						</Link>
					) : (
						<>
							{item?.authorizedField && !isAuthorized ? ( // show block (with auth modal on click) for unauthorized user
								<ServiceElement
									key={`${item.link}_not_auth`}
									icon={item.icon}
									text={item.text}
									aria-label={item.ariaLabel}
									onClick={onOpenAuthModal}
								/>
							) : (
								<>
									<Link key={`${item.link}_link`} href={item.link} aria-label={item.ariaLabel} prefetch={false}>
										<ServiceElement icon={item.icon} text={item.text} />
									</Link>
								</>
							)}
						</>
					)}
				</>
			)),
		[isAuthorized]
	)

	return (
		<>
			<FullWidthContainer>
				<section className={cl.root}>
					<ElementsSliderFree classNameSlide={cl.slide}>{slides}</ElementsSliderFree>
				</section>
			</FullWidthContainer>
			<Modal isOpen={isAuthModalOpen} onClose={onCloseAuthModal}>
				<Authorization />
			</Modal>
		</>
	)
}
